// extracted by mini-css-extract-plugin
module.exports = {"root":"App__root--3neFT"};